import angular from 'angular';
import swoaBreadcrumbBreadcrumb from './breadcrumb.component';

export default angular
  .module('swoa.breadcrumb', [
    swoaBreadcrumbBreadcrumb,
  ])
  .name;

